import { render, staticRenderFns } from "./intelligence.vue?vue&type=template&id=16008f76&scoped=true&"
import script from "./intelligence.vue?vue&type=script&lang=js&"
export * from "./intelligence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16008f76",
  null
  
)

export default component.exports